import React from "react";
import CartProvider from "../context/CartContext";
import MetaProvider from "../context/metaContext";
import PaymentLinkHome from ".";

export const LinkBody = () => {
  return (
    <CartProvider>
      <MetaProvider>
        <PaymentLinkHome />
      </MetaProvider>
    </CartProvider>
  )
}
export default LinkBody;